import { gql } from "@apollo/client";

export default gql`
  mutation updateCustomerProductPlan($data: UpdateCustomerProductPlanInput!){
    updateCustomerProductPlan(data: $data){
        success
        data{
            _id
            phone
            companyName
            email
            category
            autoConversationAssignment
            autoAssignmentType
            autoConversationAssignmentTime
            autoConversationAssignmentTimeUnit
            photo
            createdAt
            customerFromChannel
            country
            package{
                _id
                name
                type
                price
                feeCharged
                paymentStatus
                periodMode
                periodCount
                endDate
                refreshDate
                freeTrialExpiringDate
                customer
                createdAt
                ipAddress
                couponCode{
                    _id
                    customer
                    name
                    code
                    status
                    valueType
                    value
                    maxRedemptions
                    timesRedeemed
                    usageType
                    usageLimit
                    usageCount
                    expiredAt
                    createdAt
                    updatedAt
                }
                accountBalance
                addOns{
                    _id
                    name
                    quantity
                    renewalType
                    price
                    cancelAtPeriodEnd
                    credits
                    nextCredits
                }
                paymentFromOtherChannel
                features{
                    dashboard
                    inbox
                    inboxPrivateMessage
                    inboxBulkActions
                    inboxCustomViews
                    inboxMessageTranslation
                    contacts
                    contactsDynamicGroups
                    contactsMergeContacts
                    contactsImport
                    contactsExport
                    statistics
                    statisticsConversations
                    statisticsMessages
                    statisticsUsers
                    statisticsPerformance
                    statisticsSatisfactions
                    statisticsAbandonedCarts
                    statisticsCampaign
                    settings
                    settingsUsers
                    settingsUserRoles
                    settingsActions
                    settingsAuthentications
                    settingsApiKeys
                    settingsWebhooks
                    settingsTeams
                    settingsTags
                    settingsQuickAnswers
                    settingsAutoAssignment
                    settingsTeamGoals
                    settingsSlaPolicies
                    settingsTopics
                    settingsTopicsAutoFill
                    settingsCustomFields
                    settingsSurveys
                    channels
                    channelsLiveChat
                    channelsCustomChannel
                    channelsForm
                    channelsLiveChatRemoveQpienLogo
                    channelsEmail
                    channelsSms
                    channelsPhone
                    channelsWhatsAppWeb
                    channelsWhatsAppBusinessApi
                    channelsMetaWhatsAppBusinessApi
                    channelsTelegram
                    channelsFacebookDm
                    channelsFacebookComment
                    channelsInstagramDm
                    channelsInstagramComment
                    channelsTiktokDm
                    channelsTiktokComment
                    channelsMarketplace
                    campaignEngineV2
                    automation
                    automationFlowBots
                    teamChat
                    automationEcommerce
                    automationFlowBotsHttpRequest
                    automationFlowBotsStartFlow
                    channelsEcommerce
                    channelsPhoneCallRecord
                    channelsPhoneInboundCalls
                    channelsPhoneSurvey
                    channelsPhoneOutboundCalls
                    channelsPhoneTestToSpeech
                    channelsPhonelVR
                    statisticsConversationTags
                    ai
                    aiAnalysis
                    AiAgent
                    AiAssistant
                    AiClosingTag
                    AiClosingNote
                    AiClosingSurvey
                    AiStartFlow
                    AiStatistics
                    aiImageRecognition
                    aiHumanReplyLearning
                    bulkSharing
                    zohoIntegration
                    collageSharing
                    tasks
                    snooze
                    messageSchedule
                    channelsPhoneCallTranscripts
                    channelsPhoneCallAiAnalysis
                    removeEmailQpienLogo
                    tables
                    customReports
                    channelOwner
                    userActivity
                    autoAway
                }
                limits{
                    cPerson
                    cPersonRoles
                    person
                    whatsAppWeb
                    whatsAppBusiness
                    metaWhatsAppBusiness
                    liveChat
                    customChannel
                    form
                    facebook
                    email
                    instagram
                    tiktok
                    telegram
                    trendyol
                    hepsiburada
                    ebay
                    kaufland
                    pazarama
                    walmart
                    n11
                    teams
                    apiKeys
                    webhooks
                    inboxRules
                    flowBots
                    survey
                    message
                    amazon
                    aiAnswers
                    zoho
                    callMinutes
                    phone
                    aiAssistant
                    ticket
                    qpienShop
                    ikas
                    faprika
                    ticimax
                    tsoft
                    ideasoft
                    shopify
                    googleBusiness
                    slaPolicies
                    tables
                    tableRecords
                    customReports
                    operatorCredits
                }
                usages{
                    cPerson
                    cPersonRoles
                    person
                    whatsAppWeb
                    whatsAppBusiness
                    metaWhatsAppBusiness
                    liveChat
                    customChannel
                    form
                    facebook
                    email
                    instagram
                    tiktok
                    telegram
                    trendyol
                    hepsiburada
                    ebay
                    kaufland
                    pazarama
                    walmart
                    n11
                    teams
                    apiKeys
                    webhooks
                    inboxRules
                    flowBots
                    survey
                    message
                    amazon
                    aiAnswers
                    zoho
                    callMinutes
                    phone
                    aiAssistant
                    ticket
                    qpienShop
                    ikas
                    faprika
                    ticimax
                    tsoft
                    ideasoft
                    shopify
                    googleBusiness
                    slaPolicies
                    tables
                    tableRecords
                    customReports
                    operatorCredits
                }
                reChargeSettings{
                    limit
                    chargeAmount
                    isEnabled
                }
            }
            timeZone
            currency
            isANewCustomer
            isDummy
            accountStatus
            accountConfirmation
            appStatus
            language
            allowConnect
            is2FARequired
            teamGoalTime
            teamOnlineGoalTime
            teamFirstResponseGoalTime
            sendAutoSurvey{
                status
                time
                closingMessage
                surveyId
                channels
                tagRule
                tags
            }
            closingNote{
                isEnabled
                autoFillWithAi
                isCompletionRequired
                customFields{
                    _id
                    name
                    label
                    description
                    type
                    listValues
                    conditions{
                        parentField
                        parentValues
                    }
                    visibleToCustomers
                    visibleToUsers
                    status
                    isDefault
                    customer
                    createdAt
                    updatedAt
                    mediaType
                }
            }
            cPersonsAutoAwayTime
            autoApproveSharingRequests
            canManageOtherUserConversation
            allowUnassignedTicket
            twSubAccount{
                sid
                token
                apiKeySid
                apiKeySecret
            }
            onboarding{
                channelConnected
                teamInvited
                accountCustomized
                aiAgentTrained
                mobileAppDownloaded
                introVideoWatched
                completedCount
                totalCount
                isVisible
            }
            partnerCode
            signUpMethod
        }
        code
        message
    }
}
`
